<template>
<div class="row primary-filter">
  <div class="col-10 filter-grid">
    <ul>
      <li class="app-side-menu">
        <span @click="$router.go(-1)" class="pointer">
            <svgicon name="arrow-down" width="20" height="20" :original="true" class="back-arrow" />
        </span>
      </li>
      <li class="category">
        <div class="dropdown">
          <div class="dropdown-selected">
            <span v-if="hideEdits">Invoice</span>
            <span v-else>{{invoiceNo}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="col-2 filter-grid filter-button">
    <ul class="filter-btn-group">
      <li v-if="hideSave">
        <button class="btn btn-secondary" @click="save">Save</button>
      </li>
      <li>
        <!-- <router-link :to="{ name: 'Invoice'}"> -->
          <button class="btn btn-primary" @click="saveInvoice">Next</button>
        <!-- </router-link> -->
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

const calculateTotal = (selected, seg) => {
  let total = 0;
  for (const i in selected) {
    for (const j in selected[i].charges) {
    if (selected[i].charges[j]['total_amount'][seg]) {
      if (total === null) {
        total = 0;
      }
      total += Number(selected[i].charges[j].total_amount[seg]);
    }
   }
  }
  return { total, taxTotal: 0 };
};


export default {
  components: {

  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
      currentClient: 'app/currentClient',
      transporterNonGst: 'app/transporterNonGst',
    }),
    hideSave() {
      return !this.$store.showInvoice;
    },
    hideEdits() {
      return !this.$store.showInvoice;
    },
    invoiceNo() {
      return this.$store.invoice.invoice_number;
    },
  },
  methods: {

    onCloseMenu() {
      // this.isOpen = false;
    },
    async saveInvoice() {

      const hasEditFeature = this.$hasFeature('edit_invoice_post_invoice');

      if ((!this.$store.showInvoice )|| hasEditFeature) {
        const selected = [...this.$store.payments.selected];
        const passPyaments = [...selected];
        const { total: transporterTotal } = calculateTotal(
          this.$store.payments.selected,
          'transporter',
        );
        if (transporterTotal === 0) {
          this.$error({ message: 'Please enter charges' });
          return false;
        }
        const myData = passPyaments.map((payment) => {
          const { id, charges, filter_type } = payment;
          let setFilterType = filter_type;

          const consignemntCharges = charges.map(consignment => {
            return {
              consignee_id: consignment.consignee_id,
              contract_charge: consignment.contract_charge.transporter,
              lr_charge: consignment.lr_charge.transporter,
              oda_charges: consignment.oda_charges.transporter,
              unloading_charge: consignment.unloading_charge.transporter,
              loading_charge: consignment.loading_charge.transporter,
              extra_charges: consignment.extra_charges.transporter,
              additional_point_charges: consignment.additional_point_charges.transporter,
              arrival_charge: consignment.arrival_charge.transporter,
              loading_detention_charge: consignment.loading_detention_charge.transporter,
              leakage_charge: consignment.leakage_charge.transporter,
              shortage_charge: consignment.shortage_charge.transporter,
              damage_charge: consignment.damage_charge.transporter,
              carton_damage_charge: consignment.carton_damage_charge ? consignment.carton_damage_charge.transporter : 0,
              unloading_detention_charge: consignment.unloading_detention_charge.transporter,
              transit_charge: consignment.transit_charge.transporter,
              wallet_penalty_charge: consignment.wallet_penalty_charge?consignment.wallet_penalty_charge.transporter:0,
            };
        });
        return {id, charges: consignemntCharges, filter_type: setFilterType};
        });

        this.$store.dispatch('payment/save', myData);
        await this.created();
      }
        const transporter = this.currentTransporter;
        const transporterGst = transporter.gst_details.find(gst => gst.client_id === (this.currentClient && this.currentClient.id));
        const { total: systemFinalTotal, taxTotal: systemTax } = calculateTotal(
        this.$store.payments.selected,
        'system',
        );
        const { total: clientFinalTotal, taxTotal: clientTax } = calculateTotal(
        this.$store.payments.selected,
        'client',
        );
        const {
        total: transporterFinalTotal,
        taxTotal: transporterTax,
        } = calculateTotal(this.$store.payments.selected, 'transporter');

        this.$store.payments.paid_to = (transporterGst) ? transporterGst.type : '1';
        this.$store.payments.igst_tax = (transporterGst) ? transporterGst.percentage : '';
        this.$store.payments.state_tax = (transporterGst) ? (transporterGst.percentage / 2) : 0;
        this.$store.payments.central_tax = (transporterGst) ? (transporterGst.percentage / 2) : 0;
        this.$store.payments.system_total = systemFinalTotal;
        this.$store.payments.client_total = clientFinalTotal;
        this.$store.payments.transporter_total = transporterFinalTotal;
        this.$router.push({ name: 'Invoice' });
      
    },

    back() {
      // this.isOpen = true;
    },
    async created() {
      try {
        if(this.$store.invoiceId)
        {
          const result = await this.$store.dispatch('payment/showinvoice', {
            id: this.$store.invoiceId,
          });
          this.$store.invoice = result;
          this.$store.payments = {
            selected: result.payments,
          };
        }
      } catch (err) {
        this.$error({ message: 'Unable to fetch invoice' });
      }

  },
    async save() {

      await this.saveInvoice();
      this.$success({ message: 'Payment saved' });
    },
    checkIndentType(payment) {
      return ['unloading_detention_charge','loading_detention_charge','transit_charge','shortage_charge', 'damage_charge', 'leakage_charge'].some(function(k) {
      return payment[k].transporter > 0 ;
     });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@common/styles-transporter/settings";

.back-arrow {
  transform: rotate(90deg);
}

.primary-filter {
    border: 1px solid #DEE5E6;
    background-color: #fff;
    height: 50px;
    margin-left: -20px;
    margin-right: -20px;
    font-family:$fontSemibold;
    .dropdown-menu {
        top: 32px !important;
    }
    .filter-grid {
        padding-left: 0;
        padding-right: 0;
        // border-left: 1px solid #CBD4D8;
        ul {
            @extend %list-unstyled;
            li {
                display: inline-block;
            }
            .app-side-menu {
                // background-color: #F2F1F1;
                padding: 14px 0;
                width: 69px;
                text-align: center;
                position: relative;
                top: -3px;
                background: #F2F1F1;
                cursor: pointer;
            }
            .category {
                width: 180px;
                padding: 5px 20px;
                color: #007FEA;
                padding-left: 10px;
                border-right: 1px solid #CBD4D8;
                border-left: 1px solid #CBD4D8;
                font-size: 1.4rem;
                text-transform: uppercase;
                margin-left: -3px;
                position: relative;
                top: -1px;
                height: 50px;
                .dropdown {
                    padding: 12px 10px;
                }
            }
            .search {
                padding: 0 20px;
                width: 50%;
                svg {
                    position: relative;
                    top: 0px;
                }
                input {
                    outline: none;
                    border: 1px solid transparent;
                    padding: 0 5px;
                    width: 90%;
                    font-size: 1.4rem;
                }
            }
        }
        &.filter-button {
            ul {
                @extend %list-unstyled;
                float: right;
                padding: 9.5px 20px;
                li {
                    margin: 0 0 0 18px;
                    &:last-child {
                        margin: 0 0 0 10px;
                    }
                    .btn-primary {
                        @extend %header-primary-btn;
                        @extend %bold;
                        color: #fff;
                        text-transform: uppercase;
                    }
                    .btn-secondary {
                        @extend %header-secondary-btn;
                        @extend %bold;
                        color: #008AFF;
                        text-transform: uppercase;
                    }
                }
            }
        }
    }
}
</style>
